import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";
import { motion } from "framer-motion";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
        data-testid="pay-cancel"
        className="w-full max-w-md rounded-3xl border border-border bg-card p-10 text-center">
        <XCircle className="h-12 w-12 mx-auto text-muted-foreground mb-6" />
        <h1 className="font-heading text-2xl font-light">Pagamento annullato</h1>
        <p className="text-sm text-muted-foreground mt-2 mb-8">
          Nessun addebito effettuato. Puoi passare a Pro quando vuoi.
        </p>
        <div className="flex gap-3 justify-center">
          <Button data-testid="back-pricing-btn" onClick={() => nav("/pricing")}
            className="rounded-full bg-brand-blue hover:bg-brand-blue/90 text-white">Vedi i piani</Button>
          <Button variant="outline" onClick={() => nav("/app")} className="rounded-full">Continua gratis</Button>
        </div>
      </motion.div>
    </div>
  );
}
